// ─── Admin 페이지 공통 상수 ───────────────────────────────────────────────────

export const PER_PAGE = 15;

export const STATUS_KEYS = ['all', 'success', 'error'];

export const STATUS_META = {
  success: { label: 'SUCCESS', dot: 'bg-emerald-500', pill: 'bg-emerald-50 text-emerald-800' },
  error:   { label: 'ERROR',   dot: 'bg-red-500',     pill: 'bg-red-50 text-red-800' },
};

export const STATUS_COLORS = {
  success: '#10b981',
  error:   '#ef4444',
};

export const PAGE_TITLES = {
  dashboard:  { h: '대시보드',   sub: '질의·응답 지표 요약 (전체 사업장)' },
  inquiries:  { h: '질의 현황',  sub: '산업안전보건법 AI 챗봇 운영 관리' },
};
